import React from "react"
import ReactTooltip from "react-tooltip"

import "./style.scss"

const aboutReportText = {
  VendorFocus:
    "ETR Vendor Focus reports highlight specific vendors or vendor groups at a given point in time, compiling IT decision maker commentary and our proprietary data to provide insights on vendor positioning, competitive pressures, and end user sentiment.",
  IndustryAnalysis:
    "ETR Industry Analysis reports provide in-depth analysis on sector-level trends, macro takeaways, newsworthy issues, and event-based research.",
  ObservatoryReport:
    "Following a proprietary methodology of data-backed analysis, the ETR Observatory is designed to assess IT decision-maker usage of a vendor’s product and services within a specific subsector. These reports position subsector competitors relative to their peers based solely on data from the ETR Market Array.",
}

export const AboutReportTab = ({ reportType }) => {
  return (
    <p className="shared-insights-about-report-tab">
      {aboutReportText[reportType] ? aboutReportText[reportType] : null}
    </p>
  )
}

export const AboutReportTooltip = ({ reportType, ...rest }) => {
  const tooltipText = aboutReportText[reportType]
    ? aboutReportText[reportType]
    : null
  if (!tooltipText) return null

  return (
    <ReactTooltip
      {...rest}
      effect="solid"
      backgroundColor="#004c6e"
      multiline={true}
      className="report-type-tooltip"
    >
      <span>{tooltipText}</span>
    </ReactTooltip>
  )
}
